import { initialGlobalState } from './global.context';
import { GlobalActions } from './types';
export const globalReducer = (state, action) => {
    switch (action.type) {
        case GlobalActions.reset:
            return initialGlobalState;
        case GlobalActions.showNotification:
            return Object.assign(Object.assign({}, state), { notification: {
                    message: action.payload.message,
                    title: action.payload.title,
                    type: action.payload.type,
                    customContent: action.payload.customContent,
                } });
        case GlobalActions.hideNotification:
            return Object.assign(Object.assign({}, state), { notification: initialGlobalState.notification });
        case GlobalActions.openModalBasic:
            return Object.assign(Object.assign({}, state), { modalBasic: {
                    open: true,
                    title: action.payload.title,
                    body: action.payload.body,
                    buttons: action.payload.buttons,
                    maxWidth: action.payload.maxWidth,
                } });
        case GlobalActions.hideModalBasic:
            return Object.assign(Object.assign({}, state), { modalBasic: initialGlobalState.modalBasic });
        case GlobalActions.setCountry:
            return Object.assign(Object.assign({}, state), { country: action.payload });
        case GlobalActions.setUserProfile:
            return Object.assign(Object.assign({}, state), { userProfile: action.payload });
        case GlobalActions.setCommercialProcessesById:
            return Object.assign(Object.assign({}, state), { commercialProcessesById: action.payload });
        case GlobalActions.setCommercialProcessSelected:
            return Object.assign(Object.assign({}, state), { commercialProcessSelected: action.payload });
        default:
            return state;
    }
};
